import { IMenu } from "types/gaiaComponents/menu";

export const Menu = (props: IMenu) => {
    return (
        <div className={["ga-menu", props.className].filter(Boolean).join(" ")}
             data-cy={props.dataCy}>
            {props.title && <div className="ga-menu__title">{props.title}</div>}
            {props.children}
        </div>
    );
}
